import { IDataTableOptionalProps } from "../../DataTable/common/defaults";

export const userTableColumns = [
    {
        title:"Edit User",
        data:'id'
    },
    {
        title:"Username",
        data:"username"
    },
    {
        title:"User",
        data: (row,type,set,meta) => {
            return row.firstName + " " + row.lastName;
        }
    }
]

export const userTableOptions:IDataTableOptionalProps = {
    showSelectInfo: false,
    lengthChange:false,
    order:[[1,'asc']]
}


